/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNorthStar = createReactComponent("outline", "north-star", "IconNorthStar", [["path", { "d": "M3 12h18", "key": "svg-0" }], ["path", { "d": "M12 21v-18", "key": "svg-1" }], ["path", { "d": "M7.5 7.5l9 9", "key": "svg-2" }], ["path", { "d": "M7.5 16.5l9 -9", "key": "svg-3" }]]);

export { IconNorthStar as default };
//# sourceMappingURL=IconNorthStar.mjs.map
